<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/office">事業所一覧</router-link>
            </li>
            <li class="breadcrumb-item active">事業所</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-md-12">
          <!-- Column -->
          <div class="card edit-card">
            <div class="card-body">
              <form @submit.prevent="onSubmit">
                <div class="form-body">
                  <h3 class="card-title">事業所情報</h3>
                  <hr>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row" :class="{'has-danger': errors.display_name }">
                        <div class="col-md-3">
                          <label class="control-label">事業所名</label>
                        </div>
                        <div class="col-md-9">
                          <input type="text"
                                class="form-control"
                                name="display_name"
                                v-model="displayName"
                                :class="{'form-control-danger': errors.display_name }">
                          <small class="form-control-feedback" v-if="errors.display_name">
                            {{ errors.display_name }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <!--/span-->
                    <div class="col-md-3">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label class="control-label">略称</label>
                        </div>
                        <div class="col-md-9">
                          <input type="text" class="form-control" v-model="shortName">
                        </div>
                      </div>
                    </div>
                    <!--/span-->
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label class="control-label">フリガナ</label>
                        </div>
                        <div class="col-md-9">
                          <input type="text" class="form-control" v-model="furiganaValue">
                        </div>
                      </div>
                    </div>
                    <!--/span-->
                  </div>
                </div>
                <div class="form-actions">
                  <hr/>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <a href="#" @click.prevent="back">キャンセル</a>
                      <span class="mx-2"></span>
                      <template v-if="isCreateMode">
                        <button type="submit" class="action-button btn btn-success btn-rounded">登録する</button>
                      </template>
                      <template v-else>
                        <button type="button"
                                class="action-button btn btn-danger btn-rounded"
                                v-b-modal.delete-confirm-modal>
                          削除する
                        </button>
                        <span class="mx-2"></span>
                        <button type="submit" class="action-button btn btn-success btn-rounded">保存する</button>
                      </template>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
    </div>
    <delete-confirm-modal modal-id="delete-confirm-modal" entity-name="事業所" data-name="テスト" @delete="handleDelete"/>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useForm, useField } from 'vee-validate'
import * as yup from 'yup'
import co from 'co'
import { useExecutor } from '../../libs/Executor'
import DeleteConfirmModal from '../../components/DeleteConfirmModal'

// Initialize executor and router
const { exec } = useExecutor()
const route = useRoute()
const router = useRouter()

// State
const isCreateMode = ref(false)

// Form validation schema
const validationSchema = yup.object({
  display_name: yup.string().required('事業所名は必須項目です')
})

// Setup form with vee-validate
const { handleSubmit, errors } = useForm({
  validationSchema
})

// Register fields with camelCase variables
const { value: displayName } = useField('display_name')
const { value: shortName } = useField('short_name')
const { value: furiganaValue } = useField('furigana')

// Initialize data
onMounted(() => {
  exec((_this) => {
    isCreateMode.value = isNaN(route.params.id)
  })
})

// Methods
const onSubmit = handleSubmit(values => {
  exec(() => {
    return co(function * () {
      console.log('Saving data:', values)
      // Implement save logic here
    })
  })
})

const handleDelete = () => {
  router.back()
}
</script>

<style scoped>

</style>
